<template>
  <div>
    <v-select
      v-model="model.data"
      :options="model.data"
      class="w-100"
      taggable
      multiple
      append-to-body
      :create-option="(text) => ({ label: text, value: text })"
      :calculate-position="withPopper"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import popperHelper from '@/libs/popper-helper';

const TYPE = "checkbox";
const MODEL = {
  data: [],
}

export default {
  props: {
    data: Object,
    config: Object,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      model: MODEL,
    };
  },
  created() {
    const isDataEmpty = JSON.stringify(this.data.data) === "{}";
    this.model = this.data;

    if (isDataEmpty || TYPE !== this.config.type) {
      this.model.data = [];
    } else {
      this.model.data = this.data.data;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  }
};
</script>

<style></style>
